import { useContext, useEffect, useState } from "react";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import FilterToggleKeyword from "./FilterToggleKeyword";
import SearchDialogModal from "~/features/SearchV3/components/SearchDialog/SearchDialogModal";
import useSolrMetaData from "~/features/SearchV3/hooks/useSolrMetaData";
import FilterKeywordModal from "./FilterKeywordModal";
import { useLocation } from "react-router-dom";

const FilterKeyword = () => {
    const { isModalOpen } = useSolrMetaData();
    const { searchTerm, setTriggerSearch } = useContext(AdvancedSearchContext);
    const location = useLocation();

    const [textValue, setTextValue] = useState(searchTerm);

    useEffect(() => {
        setTriggerSearch(true);
    }, [location.key]);

    return (
        <>
            <FilterToggleKeyword label={textValue} />
            <SearchDialogModal open={isModalOpen}>
                <FilterKeywordModal setTextValue={setTextValue} />
            </SearchDialogModal>
        </>
    );
};

export default FilterKeyword;
